import { useMatches } from "react-router";
import { useEffect } from "react";
import { isRouteHandle } from "../infrastructure/routing/routes";

export function DocumentTitle() {
  const matches = useMatches();

  useEffect(() => {
    const match = [...matches].reverse().find((m) => isRouteHandle(m.handle));

    const title =
      match && isRouteHandle(match.handle) ? match.handle.title : undefined;

    document.title = title
      ? `${title} | Virksomhetsregistrering`
      : `Virksomhetsregistrering`;
  }, [matches]);

  return null;
}
